import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Button,
  Container,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  Toolbar,
  useTheme,
  useMediaQuery,
  Stack,
  Fade,
  Slide,
  Divider,
  Paper,
} from "@mui/material";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import PrivacyPolicyComponent from "../components/PrivacyPolicyComponent";

// Main Component
const PrivacyPolicy = () => {
  return (
     <Box
          sx={{
            bgcolor: "background.default",
            color: "text.primary",
            minHeight: "100vh",
          }}
        >
      <Navigation />
      <Container maxWidth="lg" sx={{ py: 6 }}>
          <PrivacyPolicyComponent />
      </Container>
      <Footer />
    </Box>
  );
};

export default PrivacyPolicy;